<template>
    <ListingSettingsHeader
        :filters="filters"
        :enableColumnsSettings="true"
        @selectFilter="updateActiveFilters"
        @updateColumns="updateColumns"
    >
        <template #filters>
            <component
                :is="activeFilter.component"
                v-for="activeFilter in getActiveFilters"
                :key="activeFilter.code"
                class="listing-table-filters__item"
                v-bind="activeFilter"
                :filter="activeFilter"
                @update:displayDropdown="(value) => displayDropdown(activeFilter, value)"
                @updateFilter="(values) => updateFilter(activeFilter, values)"
                @removeFilter="removeActiveFilter(activeFilter)"
            />
        </template>
    </ListingSettingsHeader>
</template>

<script>
import ListingSettingsHeader from 'vcomponents/common/listing/header/ListingSettingsHeader.vue';
import ListingFiltersSearch from 'vcomponents/common/listing/filters/types/ListingFiltersSearch.vue';
import ListingFiltersSelect from 'vcomponents/common/listing/filters/types/ListingFiltersSelect.vue';
import ListingFiltersSelectUsers from 'vcomponents/common/listing/filters/types/users/ListingFiltersSelectUsers.vue';

export default {
    components: {
        ListingSettingsHeader,
        ListingFiltersSearch,
        ListingFiltersSelect,
        ListingFiltersSelectUsers,
    },
    props: {
        filters: {
            type: Array,
            required: true,
        },
    },
    computed: {
        getActiveFilters() {
            return this.filters.filter((filter) => filter.isActive);
        },
    },
    methods: {
        updateFilter(filterToUpdate, filterValue) {
            this.$emit('updateFilter', {
                filterCode: filterToUpdate.code,
                filterValue: filterValue,
                filterOptionsSelected: filterValue,
            });
        },
        updateActiveFilters(filter) {
            this.$emit('updateActiveFilters', {
                ...filter,
                isActive: true,
                displayDropdown: true,
            });
        },
        removeActiveFilter(filter) {
            this.$emit(
                'updateActiveFilters',
                {
                    ...filter,
                    value: [],
                    optionsSelected: [],
                    isActive: false,
                    displayDropdown: true,
                },
                filter.value.length > 0,
            );
        },
        displayDropdown(filter, value) {
            filter.displayDropdown = value;
        },
        updateColumns(newColumns) {
            this.$emit('updateColumns', newColumns);
        },
        updatePagination(newPagination) {
            this.$emit('updatePagination', newPagination);
        },
    },
};
</script>
